import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 26 26",
  class: "hadrian-icons arrow"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#5D5C5C",
      "fill-rule": "nonzero",
      d: "M7.98 9.08l-.98.97L12.84 16 19 10l-.96-1-5.18 5.05z"
    }, null, -1)
  ]))]))
}